var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-form"},[_c('div',{staticClass:"my-5 row justify-content-md-center",staticStyle:{"margin":"0"}},[_c('div',{staticClass:"col-12 col-md-11 col-lg-10 col-xl-9"},[_c('Wizard',{attrs:{"forms":[
               _vm.Product.forms.add_user,
               _vm.Product.forms.general_configs,
               _vm.Product.forms.add_charges,
               _vm.Product.forms.target_market ]}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }